<template>
  <div>
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="AdminIndex" label="Admin" />
      <slot name="breadcrumb"></slot>
    </breadcrumb-list>
    <section>
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-2">
            <div class="box">
              <b-menu>
                <b-menu-list label="User Content">
                  <b-menu-item
                    label="Organizations"
                    tag="router-link"
                    :to="{ name: 'AdminOrganizationList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Inquiries"
                    tag="router-link"
                    :to="{ name: 'AdminInquiryList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Blanket VOB"
                    tag="router-link"
                    :to="{ name: 'AdminBlanketVOBList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Patient Verifications"
                    tag="router-link"
                    :to="{ name: 'AdminPatientVerificationList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Batch Reports"
                    tag="router-link"
                    :to="{ name: 'AdminBatchInquiryList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reim Aggregations"
                    tag="router-link"
                    :to="{ name: 'AdminReimbursementAggregationList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Providers"
                    tag="router-link"
                    :to="{ name: 'AdminProviderList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Users"
                    tag="router-link"
                    :to="{ name: 'AdminUserList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Invites"
                    tag="router-link"
                    :to="{ name: 'AdminInviteList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Populate Registration"
                    tag="router-link"
                    :to="{ name: 'RegistrationPopulate' }"
                  ></b-menu-item>

                  <b-menu-item
                    label="Notifications"
                    tag="router-link"
                    :to="{ name: 'AdminNotificationManager' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Mobile app version"
                    tag="router-link"
                    :to="{ name: 'AdminMobileAppVersionPolicy' }"
                  ></b-menu-item>
                </b-menu-list>
                <b-menu-list label="System Content">
                  <b-menu-item
                    label="Payers"
                    tag="router-link"
                    :to="{ name: 'AdminPayerList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reimbursements"
                    tag="router-link"
                    :to="{ name: 'AdminReimbursementList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reim Payers"
                    tag="router-link"
                    :to="{ name: 'AdminReimbursementPayerList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reim Employers"
                    tag="router-link"
                    :to="{ name: 'AdminReimbursementEmployerList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reim Groups"
                    tag="router-link"
                    :to="{ name: 'AdminReimbursementGroupList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reim Prefixes"
                    tag="router-link"
                    :to="{ name: 'AdminReimbursementPrefixList' }"
                  ></b-menu-item>

                  <b-menu-item
                    label="Payers Prefixes"
                    tag="router-link"
                    :to="{ name: 'AdminPayersPrefixesUpload' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Payers"
                    tag="router-link"
                    :to="{ name: 'AdminAlertPayerList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Group Numbers"
                    tag="router-link"
                    :to="{ name: 'AdminAlertGroupNumberList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Group Names"
                    tag="router-link"
                    :to="{ name: 'AdminAlertGroupNameList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Plan Numbers"
                    tag="router-link"
                    :to="{ name: 'AdminAlertPlanNumberList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Plan Names"
                    tag="router-link"
                    :to="{ name: 'AdminAlertPlanNameList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Insurance Types"
                    tag="router-link"
                    :to="{ name: 'AdminAlertInsuranceTypeList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Alert Prefixes"
                    tag="router-link"
                    :to="{ name: 'AdminAlertPrefixList' }"
                  ></b-menu-item>
                  <b-menu-item
                    label="Reporting"
                    tag="router-link"
                    :to="{ name: 'AdminReporting' }"
                  ></b-menu-item>
                </b-menu-list>
              </b-menu>
            </div>
            <div class="box">
              <b-menu>
                <b-menu-list label="Danger Zone">
                  <b-menu-item label="Frontend Error" @click="throwFrontendError"></b-menu-item>
                  <b-menu-item label="Backend Error" @click="throwBackendError"></b-menu-item>
                </b-menu-list>
              </b-menu>
            </div>
          </div>
          <div class="column">
            <slot name="default"></slot>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import request from '../request';

export default {
  name: 'AdminIndex',
  data() {
    return {
      loading: false,
      active: 'organizations',
    };
  },
  methods: {
    throwFrontendError() {
      throw new Error('Sentry Error');
    },
    throwBackendError() {
      request.post('/admin/error').catch();
    },
  },
};
</script>
